import {
  ARCHIVED_CHAT_LIST_QUERY_KEY,
  DEFAULT_CHAT_LIST_LIMIT,
  DEFAULT_CHAT_LIST_OFFSET,
} from "@frontend-shared/constants";
import type { IChatListResponse } from "@frontend-shared/types";
import { useInfiniteQuery } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

interface IUseArchivedChatListProps {
  enabled?: boolean;
}

export const useArchivedChatList = ({
  enabled = false,
}: IUseArchivedChatListProps = {}) => {
  return useInfiniteQuery<IChatListResponse, Error>({
    queryKey: [ARCHIVED_CHAT_LIST_QUERY_KEY],
    queryFn: ({ pageParam }) =>
      chatApi.getArchivedChatList({
        limit: DEFAULT_CHAT_LIST_LIMIT,
        offset: (pageParam as number) * DEFAULT_CHAT_LIST_LIMIT,
      }),
    initialPageParam: DEFAULT_CHAT_LIST_OFFSET,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.hasNextPage ? allPages.length : undefined;
    },
    enabled,
  });
};
